export default {
  auth0: {
    audience: 'https://api.material.com/',
    clientId: 'wklYa7h557v4NT4XZsH3epPYzKEtkPrZ',
    domain: 'material.auth0.com',
    grantType: 'http://auth0.com/oauth/grant-type/password-realm',
    login: 'https://material.auth0.com/oauth/token',
    realm: 'Username-Password-Authentication',
    scope: 'openid profile'
  },
  redirectingText: 'Redirecting...',
  v1: {
    login: 'https://mrkt-login-api.appspot.com/api_v1/login',
    reset: 'https://store.volusion.com/login_sendpass.asp'
  },
  v2: {
    activity: 'https://mrkt-data-analytics.appspot.com/v2admin/trialactivity',
    admin: 'https://admin.volusion.com',
    info: 'https://api.material.com/users?email=',
    reset: 'https://api.material.com/admin/passwordreset'
  },
  version: '1.2.2'
};
